// Server-side durability for the progress that used to live only in the browser. localStorage stays
// the working store (every reader/writer is unchanged and synchronous); this adds a load-on-login +
// debounced write-through so the same data also lives in Supabase, keyed by the authenticated user.
// Clear your cache or switch devices and your streak/checks/assessment come back.
import axios from "axios";
import { API_BASE_URL } from "./apiBase";

const API = `${API_BASE_URL}/api`;
const STARTED_KEY = "stride_plan_started_at";

const keys = (uid) => ({
  checks: `stride_checks_${uid}`,
  snap: `stride_skill_snap_${uid}`,
  assess: `stride_assess_${uid}`,
});
const readObj = (k) => { try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : null; } catch { return null; } };

// Pull the server's copy into localStorage before the app reads it, so currentDay() anchors to the
// stored plan-start rather than resetting to "today" on a fresh device.
export async function hydrateProgress(uid) {
  if (!uid) return;
  try {
    const { data } = await axios.get(`${API}/progress`);
    const d = data?.data || {};
    const k = keys(uid);
    if (d.checks) localStorage.setItem(k.checks, JSON.stringify(d.checks));
    if (d.snap) localStorage.setItem(k.snap, JSON.stringify(d.snap));
    if (d.assess) localStorage.setItem(k.assess, JSON.stringify(d.assess));
    if (d.started) localStorage.setItem(STARTED_KEY, d.started);
  } catch {
    // Offline / not configured yet — the app still works off localStorage.
  }
}

let timer;
// Debounced so a burst of checks coalesces into one PUT.
export function pushProgress(uid) {
  if (!uid) return;
  clearTimeout(timer);
  timer = setTimeout(() => {
    const k = keys(uid);
    axios.put(`${API}/progress`, {
      data: {
        checks: readObj(k.checks),
        snap: readObj(k.snap),
        assess: readObj(k.assess),
        started: localStorage.getItem(STARTED_KEY),
      },
    }).catch(() => {});
  }, 800);
  if (timer && typeof timer.unref === "function") timer.unref();   // don't keep Node (tests) alive
}
